export default __webpack_public_path__ + "static/wendy-legacy-campaign-square-4a9dc1696bf0578955b5da21335583ff.jpg";